import React from 'react';
import CourseTableBlock from './CourseTableBlock';

const CourseTable = props => {
    const {
        slots,
        addChoice
    } = props;

    return (
        <div>
            <CourseTableBlock id="leistungskurse"
                headline="Leistungskurse"
                slotConfigs={slots.slice(0, 3)} 
                onOptionClick={addChoice} />

            <CourseTableBlock id="grundkurse"
                headline="Grundkurse"
                slotConfigs={slots.slice(3, 10)} 
                onOptionClick={addChoice} />
        </div>
    );
}

export default CourseTable;